module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_new04.5a3515ec.jpg";